module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/de/katrin-1de4a5e4ac3c490e67e076af933e7cd2.jpg";